/**
 * „Eigene Ablage" — ein Feld INNERHALB einer Datei-Ablagefläche, das gezogene
 * Dateien selbst annimmt (User 22.10.2026: „wenn ich ein Bild per Drag & Drop
 * ziehe … wird nur das Lila angezeigt und gar nicht hochgeladen").
 *
 * Das Notizfeld setzt ein gezogenes BILD als Notizbild in den Text, das
 * Kommentarfeld hängt JEDE Datei an. Die Karte darum (`DateiDropZoneV4`)
 * zeigte trotzdem ihr Lila „Dateien an … hochladen" über dem ganzen Feld —
 * die Ansage stimmte nicht, und nach dem Drop blieb sie stehen, weil die
 * Karte einen schon angenommenen Drop gar nicht mehr ansah.
 *
 * Das Feld trägt `data-eigene-ablage="bilder" | "dateien"`; die Karte fragt
 * mit {@link eigeneAblageUnter}, ob der Zeiger gerade über so einem Feld
 * steht, das die gezogenen Dateien wirklich nimmt — dann schweigt sie und
 * hebt stattdessen das Feld hervor.
 */
export const ATTR_EIGENE_ABLAGE = "data-eigene-ablage";

export type EigeneAblageArt = "bilder" | "dateien";

/** Trägt der Transfer (soweit beim Ziehen schon erkennbar) ein Bild? */
export function ziehtBild(dt: DataTransfer | null | undefined): boolean {
    if (!dt) return false;
    const items = Array.from(dt.items ?? []);
    // Ohne `items` (ältere Browser, jsdom) lässt sich der Typ beim Ziehen
    // nicht erkennen — dann gilt das Feld als zuständig; es prüft beim Drop
    // ohnehin selbst und reicht Nicht-Bilder an die Karte weiter.
    if (items.length === 0) {
        const files = Array.from(dt.files ?? []);
        return files.length === 0 || files.some((f) => f.type.startsWith("image/"));
    }
    return items.some((i) => i.kind === "file" && (i.type ?? "").startsWith("image/"));
}

/** Das zuständige eigene Feld unter dem Zeiger — oder `null`. */
export function eigeneAblageUnter(
    ziel: EventTarget | null,
    dt: DataTransfer | null | undefined,
): HTMLElement | null {
    const el = (ziel as Element | null)?.closest?.(`[${ATTR_EIGENE_ABLAGE}]`) as HTMLElement | null;
    if (!el) return null;
    const art = el.getAttribute(ATTR_EIGENE_ABLAGE) as EigeneAblageArt | null;
    if (art === "dateien") return el;
    if (art === "bilder") return ziehtBild(dt) ? el : null;
    return null;
}
